
import { defineComponent } from 'vue';
import BCXSkeleton from '@/components/molecules/BCXSkeleton.vue';
import ByteCookieIcon from '@/components/svg/logo/logo-circles-only.svg?inline';

export default defineComponent({
  name: 'DashboardPartnerProgramCardSkeleton',
  components: {
    BCXSkeleton,
    ByteCookieIcon,
  },
});
